import {Invoice, PaymentType} from "pages/invoices/invoices.service";
import Dexef from "assets/images/svg/dexef_logo.svg";

import {formatDate, json} from "helpers/data";

import Master from "assets/images/svg/master_intable.svg";
import Fawry from "assets/images/svg/fawry_intable.svg";
import Paypal from "assets/images/svg/paypal_intable.svg";

interface Props {
    invoices: Invoice[];
}

function InvoicesPdf({invoices}: Props) {
    const bankInvoices = invoices.filter((i) => i.paymentTypeId === PaymentType.Master.toString());
    const paypalInvoices = invoices.filter((i) => i.paymentTypeId === PaymentType.Paypal.toString());
    const fawryInvoices = invoices.filter((i) => i.paymentTypeId === PaymentType.Fawry.toString());
    return (
        <div className="container" style={{width: 1024}}>
            <div className="report-Invoice">
                <div className="pdf-header">
                    <div>
                        <img src={Dexef} alt="Dexef"/>
                        <p>DEXEF Company</p>
                        <p>1 Ibrahim Basha Street, Quweisna</p>
                        <p>1 Ibrahim Basha Street, Quweisna</p>
                        <p>VAT Reg. No. IE9692928F</p>
                    </div>
                    <div>
                        <p>Contract ID:5461230000-2345</p>
                        <p>Name:DEXEF Company</p>
                        <p>Tax Registration Number:5461230000-2345</p>
                        <p>Address:1 Ibrahim Basha Street, Quweisna</p>
                        <p>Al Minufiyah, 12345, Egypt</p>
                    </div>
                </div>
                <div className="billing">
                    <h1>Billing Report: from - to </h1>
                    <span>Paid Invoice</span>
                </div>
              <InvoiceTable invoices={bankInvoices} icon={Master} title='Bank' />
              <InvoiceTable invoices={fawryInvoices} icon={Fawry} title='Fawry' />
              <InvoiceTable invoices={paypalInvoices} icon={Paypal} title='Paypal' />
            </div>
        </div>
    );
}

interface InvoiceTableProps {
    invoices: Invoice[],
  icon:string;
    title:string
}

function InvoiceTable({invoices,icon,title}: InvoiceTableProps) {
    if (!invoices.length) return null;
    const total = invoices.reduce((t, i) => t + i.total, 0);

    return <>
        <div className="payment">
            <img src={icon} alt="Master"/>
            <p>{title}</p>
        </div>
        <div className="table">
            <table>
                <thead>
                <tr>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Period</th>
                    <th>Product Title</th>
                    <th>Invoice Title</th>
                    <th>Payment Date</th>
                    <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                {invoices.map(i => <tr>
                    <td>#{i.serial}</td>
                    <td>{formatDate(i.createDate)}</td>
                    <td>
                        {formatDate(i.startDate)} - {formatDate(i.endDate)}
                    </td>
                    <td>{i.productTitle}</td>
                    <td>{i.invoiceTitle}</td>
                    <td>{formatDate(i.paymentDate)}</td>
                    <td>
                        {i.total} {json(i.currency)}
                    </td>
                </tr>)}
                </tbody>
            </table>
            <div className="totalAmount">
                <h2>Total Amount Billed</h2>
                <p>{total}</p>
            </div>
        </div>
    </>
}

export default InvoicesPdf;
